import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Card } from "../../../../Card";
import { Header } from "../../Header";
import { Values } from "../../Values";
import { Sharing } from "../../Sharing";
import { CompactParameters } from "../../CompactParameters";
import { TopParameters } from "../../TopParameters";
import { Description } from "../../Description";
import { Footer } from "../../Footer";
import { Wait } from "../../Wait";
import { usePrepareDefault } from "../../../utils";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Default = /*#__PURE__*/memo(function (props) {
  var _usePrepareDefault = usePrepareDefault(props),
    showBtn = _usePrepareDefault.showBtn,
    showWait = _usePrepareDefault.showWait,
    hasLabel = _usePrepareDefault.hasLabel,
    labelSize = _usePrepareDefault.labelSize,
    showContent = _usePrepareDefault.showContent,
    showTopParameters = _usePrepareDefault.showTopParameters,
    showCompactParameters = _usePrepareDefault.showCompactParameters;
  var tileHeaderBgImage = props.bgImage ? "url('".concat(props.bgImage, "')") : undefined;
  return /*#__PURE__*/React.createElement(Card, {
    className: cn('default', {
      'default--dark': props.isDark
    }, {
      'default--wait': props.isLoading || props.isError
    }, props.className),
    tagName: "div",
    withHover: true,
    "data-t-id": "CardTypes-Default"
  }, showWait && /*#__PURE__*/React.createElement(Wait, {
    isError: props.isError,
    isLoading: props.isLoading,
    onError: props.onError
  }), showContent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cn('default__header', {
      'default__header--half': props.cardType === 'half' || props.cardType === 'max'
    }),
    style: {
      backgroundImage: tileHeaderBgImage,
      backgroundColor: props.bgColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('default__header__top-wrapper')
  }, /*#__PURE__*/React.createElement(Header, {
    availableOnlyInOffice: props.availableOnlyInOffice,
    badge: props.badge,
    cardType: props.cardType,
    connectedSettings: props.connectedSettings,
    discount: props.discount,
    forEsim: props.forEsim,
    isConnected: props.isConnected,
    isDark: props.isDark,
    labelSize: labelSize,
    title: props.title,
    titleSize: "size4-r"
  }), props.packages && /*#__PURE__*/React.createElement(Values, {
    cardType: props.cardType,
    hasLabel: hasLabel,
    isDark: props.isDark,
    packages: props.packages
  })), showTopParameters && /*#__PURE__*/React.createElement(TopParameters, {
    cardType: props.cardType,
    parameters: props.topParameters
  }), props.isYandex && /*#__PURE__*/React.createElement(Sharing, {
    badgeClassName: cn('badge'),
    cardType: props.cardType
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('default__body'),
    style: {
      backgroundColor: props.footerColor
    }
  }, showCompactParameters && /*#__PURE__*/React.createElement(CompactParameters, {
    badgeClassName: cn('badge'),
    cardType: props.cardType,
    compactParameters: props === null || props === void 0 ? void 0 : props.compactParameters,
    isDark: props.isDark,
    isFirst: props.isFirst,
    isLast: props.isLast,
    isYandex: props.isYandex
  }), /*#__PURE__*/React.createElement(Description, {
    description: props.description,
    showCompactParameters: showCompactParameters
  }), /*#__PURE__*/React.createElement(Footer, {
    buttonClassName: props.buttonClassName,
    buttonText: props.buttonText,
    cardType: props.cardType,
    discount: props.discount,
    isConnected: props.isConnected,
    isConstructor: props.isConstructor,
    link: props.link,
    onLinkClick: props.onLinkClick,
    price: props.price,
    priceNotLoaded: props.priceNotLoaded,
    priceNotLoadedCallback: props.priceNotLoadedCallback,
    showBtn: showBtn
  }))));
});